import i18n from 'i18next';

export default ({ isWizard } = {}) => ({
  topics: {
    type: 'TopicTagMapping',
    label: isWizard ? i18n.t('topic-tags') : i18n.t('bulk-tag-content'),
    help: i18n.t('topic-tags-help'),
    isInitiallyExpanded: !isWizard,
    // validators: [{ type: 'isNotEmptyArray' }, { type: 'isRequired' }],
  },
});
